import React from 'react'
import indianMapMobile from 'assets/who-we-are/map.png'

export default function Map() {
  return (
    <section className="bg-[#EBF6FF]">
      {/* <div className="md:block hidden blade-bottom-padding-sm lg:h-screen h-fit lg:min-h-[650px] bg-no-repeat bg-center blade-top-padding-sm bg-[url(assets/who-we-are/map.png)]">
        <div className="lg:grid grid-cols-8 md:blade-top-padding blade-bottom-padding">
          <div className="md:pl-14 xl:pl-5 col-start-1 xl:col-start-2 col-end-4 lg:min-h-[600px] min-h-[300px] blade-top-margin-md px-4 md:px-0">
            <h2 className="sg-translate leading-tight d font-normal md:block hidden text-left">
              We are where you <br /> need us
            </h2>
          </div>
        </div>
      </div> */}

      <div className="w-container blade-top-padding-lg blade-bottom-padding-lg">
        <h2 className="sg-translate   bg-gradient-to-b from-blueShade to-transparent leading-tight font-normal text-center ">
          We are where you <br /> need us
        </h2>

        <div className="bg-[#EBF6FF] px-2 z-0 md:pt-8 pt-2 ">
          <img
            className="w-full"
            src={indianMapMobile}
            alt="indian map mockups"
          />
        </div>
      </div>
    </section>
  )
}
